// @ts-strict-ignore
import * as React from 'react';
import { Typography } from 'onboarding-components';
import clsx from 'clsx';
import { TileButton } from 'common/onboarding/components/tile-button';
import { UserEventPropertiesMapContext } from 'common/onboarding/immersive-onboarding-legacy/types';
import { useTranslation } from 'common/i18n/hooks';
import styles from './index.module.styl';
import { ConnectorContext } from './connector-context';
export const EventColumn = _ref => {
  let {
    setSelectedEvent,
    selectedEvent,
    skipAnimation = false
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    eventKeys,
    currentEventPropertiesMap
  } = React.useContext(UserEventPropertiesMapContext);
  const {
    setLeftRef
  } = React.useContext(ConnectorContext);

  // Create refs for each event and store them in a ref
  const eventRefs = React.useRef([]);
  const addRef = (key: number) => {
    if (eventRefs.current[key]) {
      return eventRefs.current[key];
    } else {
      const newRef = React.createRef<HTMLDivElement>();
      eventRefs.current[key] = newRef;
      return newRef;
    }
  };
  React.useEffect(() => {
    if (skipAnimation && eventRefs.current[0]) {
      setLeftRef(eventRefs.current[0]);
    }
  }, [skipAnimation, eventRefs.current[0]]);
  return <div className={clsx(styles.eventSelectorContainer, {
    [styles.narrowEventColumn]: selectedEvent
  })} data-sentry-component="EventColumn" data-sentry-source-file="event-column.tsx">
      <Typography variant='captionSm' data-sentry-element="Typography" data-sentry-source-file="event-column.tsx">{t("onboarding-legacy.events.events-header")}</Typography>
      {eventKeys.map((event, eventIndex) => {
      var _currentEventProperti, _currentEventProperti2;
      const ref = addRef(eventIndex);
      return <TileButton style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: 50
      }} badge={selectedEvent && <div className={styles.eventBadge}>
                  <Typography variant='captionXs' weight='bold'>
                    {(_currentEventProperti = (_currentEventProperti2 = currentEventPropertiesMap.get(event)) === null || _currentEventProperti2 === void 0 ? void 0 : _currentEventProperti2.length) !== null && _currentEventProperti !== void 0 ? _currentEventProperti : 0}
                  </Typography>
                </div>} ref={ref} key={"breakdown-event-".concat(eventIndex)} className={styles.eventSelectorButton} onClick={() => {
        setSelectedEvent(event);
        setLeftRef(ref);
      }} selected={selectedEvent === event}>
            {event}
          </TileButton>;
    })}
    </div>;
};